import { render, staticRenderFns } from "./ProductSyncConfigUpgradeDialog.vue?vue&type=template&id=e8cb0d7c&scoped=true&"
import script from "./ProductSyncConfigUpgradeDialog.vue?vue&type=script&lang=js&"
export * from "./ProductSyncConfigUpgradeDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductSyncConfigUpgradeDialog.vue?vue&type=style&index=0&id=e8cb0d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cb0d7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VCard,VCardActions,VCardSubtitle,VCardText,VCardTitle,VIcon,VOverlay})
